export default {
  listStore: [],
  loading: true
}
